// extracted by mini-css-extract-plugin
export default {"fake-span":"fake_row_fake-span__CazAo","colorMove":"fake_row_colorMove__8q-a8"};